module.exports = __webpack_public_path__ + "static/img/cert-01.824ed61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cert/cert-01.jpg
// module id = FDa+
// module chunks = 1